import { BreadcrumbHeading, Spinner } from '@weareopenr/component-library';
import { Navigate, useLocation } from 'react-router-dom';
import styles from './PublicationStatusRedirect.module.scss';
import { Routes } from 'src/routes';

interface IPublicationStatusRedirectProps {
  isLoading: boolean;
  name?: string;
  eventId?: string | null;
  listLabel: string;
  listPath: string;
  notPublishedMessage: string;
}

export const PublicationStatusRedirect = ({
  isLoading,
  name,
  eventId,
  listLabel,
  listPath,
  notPublishedMessage,
}: IPublicationStatusRedirectProps) => {
  const { pathname } = useLocation();

  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner size="xlarge" colour="rainbow" />
      </div>
    );
  }

  if (eventId) {
    return <Navigate to={`${Routes.PUBLISH_HISTORY}/status/${eventId}`} state={{ entityName: name }} replace />;
  }

  return (
    <BreadcrumbHeading
      breadcrumbs={[
        { label: listLabel, path: listPath },
        { label: name, path: pathname },
      ]}
      subtitle={notPublishedMessage}
    />
  );
};
